import React from 'react'
import { ChartWrapper, Candle } from './ElementsStyles'
import { ReactComponent as HorizontalSVG } from '../../../../lib/assets/Horizontal-lines.svg'
import { ReactComponent as VerticalSVG } from '../../../../lib/assets/Vertical-lines.svg'
import { ReactComponent as SeparatorSVG } from '../../../../lib/assets/Seperator.svg'
import { ReactComponent as RedSVG } from '../../../../lib/assets/Red.svg'
import { ReactComponent as BlueSVG } from '../../../../lib/assets/Blue.svg'
export default function ChartComponent() {
  const candles = [
    {
      bg: 'green',
      height: '17px',
      rotate: '0',
    },
    {
      bg: 'grey',
      height: '33px',
      rotate: '1',
    },
    {
      bg: 'green',
      height: '37px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '55px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '46px',
      rotate: '0',
    },
    {
      bg: 'grey',
      height: '24px',
      rotate: '1',
    },
    {
      bg: 'grey',
      height: '50px',
      rotate: '1',
    },
    {
      bg: 'grey',
      height: '17px',
      rotate: '1',
    },
    {
      bg: 'green',
      height: '46px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '24px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '70px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '17px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '46px',
      rotate: '0',
    },
    {
      bg: 'grey',
      height: '24px',
      rotate: '1',
    },
    {
      bg: 'grey',
      height: '70px',
      rotate: '1',
    },
    {
      bg: 'grey',
      height: '17px',
      rotate: '1',
    },
    {
      bg: 'green',
      height: '46px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '24px',
      rotate: '0',
    },
    {
      bg: 'grey',
      height: '5px',
      rotate: '1',
    },
    {
      bg: 'grey',
      height: '17px',
      rotate: '1',
    },
    {
      bg: 'green',
      height: '17px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '75px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '7px',
      rotate: '0',
    },
    {
      bg: 'green',
      height: '35px',
      rotate: '0',
    },
  ]

  return (
    <ChartWrapper>
      <RedSVG className='red' />
      <BlueSVG className='blue' />
      <HorizontalSVG className='horizontal' />
      <SeparatorSVG className='separator' />
      <VerticalSVG className='vertical' />
      {candles.map((i: any, id: number) => (
        <Candle
          key={id}
          height={i.height}
          rotate={i.rotate}
          left={id * 13}
          bg={i.bg}
        />
      ))}
    </ChartWrapper>
  )
}
